export { FavoritesApollo as FavoritesListing } from './apollo';
